var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('patrol-search',{attrs:{"default-user-robot":1,"title":"AI电话（匹配）"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }